import { PayLetterFailProps, BaseComponentProps } from './PayLetterFail.types';

/**
 * PayLetter Fail 컴포넌트의 props를 에디터용으로 변환하는 어댑터
 */
export const adaptPayLetterFailProps = (props: any): PayLetterFailProps => {
  // 기본 BaseComponentProps 처리
  const baseProps: BaseComponentProps = {
    id: props.id,
    className: props.className || 'payletter-fail-container',
    style: props.style || {},
    componentProps: props.componentProps || {},
    isEditor: props.isEditor || false,
    isPreview: props.isPreview || false
  };

  // PayLetter Fail 전용 props 처리
  const payLetterFailProps: PayLetterFailProps = {
    ...baseProps,
    content: props.content || {},
    data: {
      title: props.data?.title || props.componentProps?.title || '결제에 실패했습니다',
      failMessage: props.data?.failMessage || props.componentProps?.failMessage || '결제가 취소되었거나 실패했습니다.',
      // retryButtonText: props.data?.retryButtonText || props.componentProps?.retryButtonText || '다시 결제하기',
      // cartButtonText: props.data?.cartButtonText || props.componentProps?.cartButtonText || '장바구니로 이동',
      homeButtonText: props.data?.homeButtonText || props.componentProps?.homeButtonText || '홈으로 돌아가기',
      ...props.data
    }
  };

  return payLetterFailProps;
}; 